// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalBiPrescriberRequest {
    static getAttributeTypeMap() {
        return MedicalBiPrescriberRequest.attributeTypeMap;
    }
}
MedicalBiPrescriberRequest.discriminator = undefined;
MedicalBiPrescriberRequest.additionalProperties = false;
MedicalBiPrescriberRequest.attributeTypeMap = [
    {
        "name": "address",
        "baseName": "address",
        "type": "MedicalBiAddress"
    },
    {
        "name": "fax",
        "baseName": "fax",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "taxId",
        "baseName": "taxId",
        "type": "string"
    },
];
//# sourceMappingURL=medicalBiPrescriberRequest.js.map